<template>
  <div class="login-page">
    <div class="login-card">
      <div class="logo">元</div>
      <h1>财务管理系统</h1>
      <p class="subtitle">管理员专用入口</p>
      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        @submit.prevent="submit"
      >
        <el-form-item prop="account">
          <el-input
            v-model="form.account"
            size="large"
            placeholder="管理员账号"
            :prefix-icon="User"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            size="large"
            type="password"
            show-password
            placeholder="密码"
            :prefix-icon="Lock"
            @keyup.enter="submit"
          />
        </el-form-item>
        <el-button
          type="primary"
          size="large"
          :loading="loading"
          class="submit"
          @click="submit"
        >
          登录财务中心
        </el-button>
      </el-form>
      <p class="hint">管理员及系统最高权限账号可登录，关闭浏览器后需重新登录</p>
    </div>
  </div>
</template>
<script setup>
import { reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { User, Lock } from '@element-plus/icons-vue'
import { financeAuthApi } from '../api'
import { FINANCE_TOKEN_KEY } from '../api/financeRequest'
import { useStore } from 'vuex'
const router = useRouter()
const route = useRoute()
const store = useStore()
const formRef = ref()
const loading = ref(false)
const form = reactive({ account: '', password: '' })
const rules = {
  account: [{ required: true, message: '请输入管理员账号', trigger: 'blur' }],
  password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
}
const submit = async () => {
  if (!(await formRef.value.validate().catch(() => false))) return
  loading.value = true
  try {
    const data = await financeAuthApi.login(form)
    sessionStorage.setItem(FINANCE_TOKEN_KEY, data.token)
    store.commit('finance/setSession', data)
    ElMessage.success('登录成功')
    router.replace(route.query.redirect || '/finance/dashboard')
  } catch (e) {
    ElMessage.error(e?.message || '登录失败，请确认管理员账号')
  } finally {
    loading.value = false
  }
}
</script>
<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f9ecec, #f6f8fb);
}
.login-card {
  width: 420px;
  background: #fff;
  border-radius: 14px;
  padding: 42px 40px;
  box-shadow: 0 18px 50px #7f1d1d16;
  text-align: center;
}
.logo {
  width: 56px;
  height: 56px;
  line-height: 56px;
  margin: 0 auto 14px;
  background: #c22525;
  color: #fff;
  font-size: 27px;
  font-weight: bold;
  border-radius: 14px;
}
.login-card h1 {
  font-size: 26px;
  color: #1e293b;
}
.subtitle {
  color: #94a3b8;
  margin: 8px 0 28px;
}
.submit {
  width: 100%;
  margin-top: 8px;
}
.hint {
  font-size: 12px;
  color: #9aa6b6;
  line-height: 1.6;
  margin-top: 24px;
}
@media (max-width: 480px) {
  .login-card {
    width: calc(100% - 32px);
    padding: 32px 24px;
  }
}
</style>
